// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { HostComponent, ViewProps } from 'react-native';
import type { Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
import codegenNativeCommands from 'react-native/Libraries/Utilities/codegenNativeCommands';
import type * as React from 'react';
interface NativeProps extends ViewProps {}
interface NativeCommands {
  scrollTo(viewRef: React.ElementRef<HostComponent<NativeProps>>, scrollID: string, hasAnchor: boolean, anchorX: Double, anchorY: Double): void;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  dispatchCommand
} = require("react-native/Libraries/ReactNative/RendererProxy");
let nativeComponentName = 'OneNativeScrollViewReader';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeScrollViewReader",
  validAttributes: {}
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);
export const Commands = {
  scrollTo(ref, scrollID, hasAnchor, anchorX, anchorY) {
    dispatchCommand(ref, "scrollTo", [scrollID, hasAnchor, anchorX, anchorY]);
  }
};